import { render } from "./backButton.vue?vue&type=template&id=a59e47ec&scoped=true&ts=true"
import script from "./backButton.vue?vue&type=script&lang=ts"
export * from "./backButton.vue?vue&type=script&lang=ts"

import "./backButton.vue?vue&type=style&index=0&id=a59e47ec&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a59e47ec"]])

export default __exports__